import React, { useMemo, useState } from 'react';
import { ChevronRightIcon, PhoneIcon } from 'lucide-react';
import { Product } from '../../types/catalog';
import { formatCurrency } from '../../utils/geo';
import { matchesFilter, supplierDirectory } from '../../utils/catalogIndex';
interface SuppliersDirectoryProps {
  filter: string;
  onCompare: (product: Product) => void;
}
export function SuppliersDirectory({
  filter,
  onCompare
}: SuppliersDirectoryProps) {
  const [openId, setOpenId] = useState<string | null>(null);
  const suppliers = useMemo(supplierDirectory, []);
  const visible = suppliers.filter(({
    quarry
  }) => matchesFilter(filter, quarry.name, quarry.operator, quarry.city, quarry.siteCode));
  if (visible.length === 0) {
    return <p className="px-5 py-8 text-center text-sm text-ink-muted" data-id="element-38" data-mp="1tss4e7xvgd5g">No suppliers match.</p>;
  }
  return <ul className="divide-y divide-line" data-id="element-39" data-mp="2raie5x8jjlsc">
      {visible.map(({
      quarry,
      entries
    }) => {
      const open = openId === quarry.id;
      return <li key={quarry.id} data-id="element-40" data-mp="1a61xvu1lckfr">
            <button type="button" onClick={() => setOpenId(open ? null : quarry.id)} aria-expanded={open} className="flex w-full items-center gap-3 px-5 py-3 text-left transition-colors duration-150 hover:bg-canvas" data-id="element-41" data-mp="1a6ths7ltstq7">
              <ChevronRightIcon className={`h-4 w-4 shrink-0 text-ink-soft transition-transform duration-150 ${open ? 'rotate-90' : ''}`} aria-hidden="true" data-id="element-42" data-mp="15ea2953kvoir" />
              <span className="min-w-0 flex-1" data-id="element-43" data-mp="wfopxrop95qf">
                <span className="block truncate text-sm font-medium text-ink" data-id="element-44" data-mp="if438kfnyprn">{quarry.name}</span>
                <span className="block truncate text-xs text-ink-soft" data-id="element-45" data-mp="mfo2btjss3gf">
                  {quarry.city}
                  {quarry.siteCode ? ` · ${quarry.siteCode}` : ''}
                </span>
              </span>
              <span className="tnum shrink-0 text-xs text-ink-soft" data-id="element-46" data-mp="2gt763l4f8ia6">
                {entries.length} {entries.length === 1 ? 'material' : 'materials'}
              </span>
            </button>

            {open && <div className="bg-canvas px-5 pb-3 pl-12" data-id="element-47" data-mp="3kqiyxw7qwfb7">
                <div className="flex flex-wrap items-center gap-x-4 gap-y-1 pb-2 text-xs text-ink-muted" data-id="element-48" data-mp="3gpz1ssn69bp2">
                  <span data-id="element-49" data-mp="3brxnel0oy0jx">
                    {quarry.address}, {quarry.city} {quarry.zip}
                  </span>
                  {quarry.phone && <a href={`tel:${quarry.phone.replace(/[^\d]/g, '')}`} className="tnum inline-flex items-center gap-1 transition-colors duration-150 hover:text-accent" data-id="element-50" data-mp="cedb6eb1bm7t">
                      <PhoneIcon className="h-3 w-3" aria-hidden="true" data-id="element-51" data-mp="3uqrz1l4uykvv" />
                      {quarry.phone}
                    </a>}
                </div>
                <p className="pb-2 text-xs text-ink-soft" data-id="element-52" data-mp="w22tzw0zuc4w">{quarry.pricingNote}</p>
                <ul className="divide-y divide-line border-t border-line" data-id="element-53" data-mp="r7gk5xak8rmx">
                  {entries.map((entry, index) => <li key={`${entry.product.id}-${index}`} data-id="element-54" data-mp="13jiyofig60ol" data-mpi={index}>
                      <button type="button" onClick={() => onCompare(entry.product)} className="group flex w-full items-baseline justify-between gap-4 py-2 text-left" data-id="element-55" data-mp="13k12bx7fvh6j">
                        <span className="min-w-0 truncate text-sm text-ink transition-colors duration-150 group-hover:text-accent" data-id="element-56" data-mp="1hiimxm21sdk8">
                          {entry.product.name}
                        </span>
                        <span className="tnum shrink-0 text-right text-sm font-medium text-ink" data-id="element-57" data-mp="1raocyq8qokws">
                          {formatCurrency(entry.price.price)}
                          <span className="ml-1 text-xs font-normal text-ink-soft" data-id="element-58" data-mp="20abfjfd7fwrf">
                            /{entry.unit}
                          </span>
                        </span>
                      </button>
                    </li>)}
                </ul>
                <p className="pt-2 text-xs text-ink-soft" data-id="element-59" data-mp="1rk1girclf1jg">
                  Tap a material to compare it against every other plant.
                </p>
              </div>}
          </li>;
    })}
    </ul>;
}